import { useEffect } from 'react';
import { recordWatchlistActivity } from '../activity';

const VISIBILITY_CHANGE_EVENT = 'visibilitychange';

// Entering the Watchlist, or coming back to its tab, is what keeps monitors from auto-pausing.
const useWatchlistActivity = enabled => {
    useEffect(() => {
        if (!enabled) return undefined;
        const touch = () => {
            if (!document.hidden) recordWatchlistActivity();
        };
        touch();
        document.addEventListener(VISIBILITY_CHANGE_EVENT, touch);
        return () => document.removeEventListener(VISIBILITY_CHANGE_EVENT, touch);
    }, [enabled]);
};

export default useWatchlistActivity;
